import { TableRow } from '@mui/material';
import { TRawData } from '../../../types/cosmosApi';
import { millisecondsToUTC } from '../../../utils/utils';
import TxCell from './TableCell';
import TxHashCell from './TxHashCell';


type TRowProps = {
    tx: TRawData, 
    isCreator: boolean,
}

const determineTxDirectionUI = ({creator, destination, isCreator}: { creator: string; destination: string; isCreator: boolean; }) => {
    if(isCreator){
        if(creator === destination){
            return {dir: "SELF", color: "white"}
        } 
        return {dir: "OUT", color: "red"}
    }
    return {dir: "IN", color: "green"}
}

const TxRow = ({tx, isCreator}: TRowProps,) => {

    
    const txDirectionUI = determineTxDirectionUI({creator: tx.creator, destination: tx.destination, isCreator})
    const timestamp = millisecondsToUTC(Number(tx.createdAt));
    
    return (
        <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
            <TxHashCell value={tx.hash} to={`/tx/${tx.hash}`}/>
            <TxCell text={txDirectionUI.dir} color={txDirectionUI.color}/> 
            <TxCell text={timestamp} /> 
        </TableRow>
    );
}
 
export default TxRow;